import React from 'react';
// LIBRARIES1
import cx from 'classnames';
import axios from 'axios';
import Slider from 'react-slick';
import call from '../../assets/call.png';
import distance from '../../assets/distance.png';
import dropdown from '../../assets/dropdown.png';
import listing from '../../assets/listing_icon.png';
import Loaders from '../../components/Loaders';
import Modal from '../../components/Modal';
/*
import {
  changeCard,
  fetchMerchantData
} from '../../redux/actions/loanCPV/fetchMerchantData';
import { fetchMerchantDetails } from '../../redux/actions/loanCPV/fetchMerchantDetails';
import { scheduleLater } from '../../redux/actions/loanCPV/scheduleLater';
import { types as loaderTypes } from '../../redux/reducers/LoaderReducer';
import { types as mlTypes } from '../../redux/reducers/LoanCPV/MerchantList';
*/
// ASSETS
import newBharatPeLogo from '../../assets/new-bharatpe-logo.jpeg';
import whatsAppIcon from '../../assets/icons/icon__whatsapp.png';
import distanceIcon from '../../assets/distance.png';
import callIcon from '../../assets/call.png';
import scanPayLogo from '../../assets/scanpay-logo.svg';
import scanPayLogoBlack from '../../assets/scanpay-logo-black.svg';
import greenTick from '../../assets/green-tick.svg';
// UTILS
import { getURLParameter } from '../../utils';
// STYLES
import './styles.scss';

var w = window;
var marking;
var maping = null;
var len = 0;
var neighborhoods = [];
var markers = [];
var markersColorPriority = {
  '1': '#FFCB2E',
  '2': '#3371FF',
  '3': '#FF0000',
  '4': '#FFA233',
  '5': '#3B2A98',
  '6': '#BBBBBB'
};
var markerDefault = require('../../assets/markers/marker--selected.svg');
var markerSelected = require('../../assets/marker.png');
var markersPriority = {
  '1': require('../../assets/markers/marker--priority-yellow.svg'),
  '2': require('../../assets/markers/marker--priority-blue.svg'),
  '3': require('../../assets/markers/marker--priority-red.svg'),
  '4': require('../../assets/markers/marker--priority-orange.svg'),
  '5': require('../../assets/marker.png')
};
var map = null;
var selected_marker = null;
var marker;

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardIndex: 0,
      merchantList: [],
      merchantActiveListItem: {},
      expandScanPayVisible: false,
      onePixelImageURL: null,
      latitude: null,
      longitude: null
    };
  }

  componentDidMount() {
    this.onMount();
    this.trackEvent('consumer_lockdown_page_loaded', {});
  }

  trackEvent = (eventName, eventParams = {}) => {
    let { state } = this;

    let eventTimestamp = Math.round((new Date()).getTime() / 1000);
    let trackingURL = `https://d1t5ygi6ibgcm3.cloudfront.net/i?event_name=${eventName}&event_params=${JSON.stringify(eventParams)}&timestamp=${eventTimestamp}`;

    if (state.latitude && state.longitude) {
      trackingURL += '&lon=' + state.longitude + '&lat=' + state.latitude;
    }

    this.setState({
      onePixelImageURL: trackingURL
    });
  }

  onMount(event) {
    const self = this;

    var options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    function onError(error) {
      console.log(error);
      alert(
        'Your GPS is disabled, To continue, your device location is required to provide necessary services.'
      );
    }

    navigator.geolocation.getCurrentPosition(
      response => {
        var onSuccess = position => {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;

          self.fetchMerchants(latitude, longitude);
          window.localStorage.setItem('latitude', latitude);
          window.localStorage.setItem('longitude', longitude);
          window.localStorage.setItem('accuracy', position.coords.accuracy);
        };

        window.navigator.geolocation.getCurrentPosition(onSuccess, onError);
      },
      onError,
      options
    );
  }

  handleInputChange(key, value, validationType, minLength, maxLength) {
    const newState = { ...this.state };
    if (value.length > maxLength) value = value.substring(0, maxLength);
    value = value.replace(
      validationType === 'email'
        ? /[^\w\@\-\.]/gi
        : validationType === 'alpha_numeric'
        ? /[^\w]/gi
        : validationType === 'alpha_space'
        ? /[^\w\d\s]/gi
        : validationType === 'address'
        ? /[^\w\s\-\,]/gi
        : /[^\d]/gi,
      ''
    );
    newState[key] = value;
    this.setState(newState);
  }

  handleIntentLocation(lat, lng) {
    window.open(`geo:?q=${lat},${lng}`);
  }

  handleIntentWhatsApp(item) {

  }

  handleIntentCall() {

  }

  handleIntentPayment(string) {

  }

  handleCommonTracking(action, item) {
    const self = this;

    self.trackEvent(`consumer_lockdown_action_${action}`, {
      id: item.mid,
      business_name: item.business_name,
      home_delivery_status: item.home_delivery_status
    });
  }

  fetchMerchants(latitude, longitude, newmap) {
    const self = this;
    let newState = { ...this.state };

    newState['latitude'] = latitude;
    newState['longitude'] = longitude;
    self.setState(newState);

    const FETCH_MERCHANT_URL = 'https://app.bharatpe.in/geodata/geo';
    
    axios
      .post(
        FETCH_MERCHANT_URL,
        {
          latitude,
          longitude
        }
      )
      .then(({ data }) => {
        const merchantData = data.data;
        newState['cardIndex'] = 0;
        newState['merchantList'] = merchantData;

        self.setState(newState);
      })
      .catch((err) => {
        console.error(err);
      });

    {/*

    */}
  }

  componentWillUnmount() {
    // this.props.dispatch({
    //   type: mlTypes.SET_CARD_INDEX,
    //   payload: 0
    // });
  }

  render() {
    const self = this;
    const { props, state } = this;
    const sliderSettings = {
      dots: false,
      className: 'slider variable-width',
      infinite: false,
      dots: false,
      arrows: false,
      speed: 500,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      initialSlide: self.props.cardIndex,
      onSwipe: function(val) {
        console.log(val);
      },
      afterChange: (k) => {
        console.log(k);
        self.changeCard(k, state.merchantActiveListItem);
      },
      beforeChange: (prev, next) => {
        console.log(prev, next);
      }
    };
    const handleArray = (stringObj) => {
      let result = [];

      stringObj.replace('[','').replace(']','').split(",").map((el, j) => {
        result.push(JSON.parse(el));
      });

      return result;
    };
    
    return (
      <div
        name="MapListing"
        className="screen map-listing-screen no-padding-screen"
        id="screen__map_listing"
      >
        <div className="header_container sticky">
          <div className="header">
            <div className="heading-wrap">
              <h1>BharatPe - Find Merchants</h1>
              <span>
                These Merchants are open in your area <br />
                during <b>Lock-Down</b>
              </span>

              <img className="bharatpe-logo" src={newBharatPeLogo} alt="bharatpe-logo" />
            </div>
          </div>
        </div>
        
        <div className="listing-wrap">
          {
            state.merchantList &&
            state.merchantList.length > 0 &&
            state.merchantList.map((item, index) => {
              // let arrayOfProducts = handleArray(item.product_type);

              return item.whatsapp_number && (
                <div
                  key={index}
                  className={`cpv-merchant-card ${item.home_delivery_status === "yes" && 'delivery'}`}
                  style={{
                    minWidth: '280px',
                  }}
                >
                  {item.home_delivery_status === "yes" && (
                    <div
                      className="priority_color"
                      style={{
                        backgroundColor: item.home_delivery_status === "yes" && '#151821'
                      }}
                    >
                      <img src={greenTick} alt="green tick icon"/>
                      <div className="delivery-text">Home Delivery Available</div>
                    </div>
                  )}

                  <div className="service-name">{item.business_name}</div>
                  <div className="flex">
                    <div className="address" style={{ marginTop: 5, flex: 1 }}>
                      Available Products are: <br />

                      <div className="product_types">
                        {item.product_type && 
                          item.product_type.length > 0 &&
                          item.product_type.map((product, i) => {
                            return (
                              <div className="chip" key={i}>{product}</div>
                            )
                          })}
                      </div>
                    </div>

                    <div
                      className="km-wrap"
                      onClick={() => {
                        self.handleCommonTracking('location', item);
                        this.handleIntentLocation(item.geo.latitude, item.geo.longitude);
                      }}
                    >
                      <img src={distance} alt="" />
                      <span style={{ fontSize: 12 }}>{parseFloat(item.distance).toFixed(1)} KM</span>
                      <span style={{ fontSize: 12 }}>View on Maps</span>
                    </div>
                  </div>

                  <div className="bottom-wrap">
                    <div className="btn-wrap">
                      <button
                        onClick={() => {
                          self.handleCommonTracking('call', item);
                          window.open(`tel:+91${item.whatsapp_number}`);
                        }}
                        style={{ outline: "none" }}
                      >
                        <img src={callIcon} alt="call icon" />
                      </button>

                      <button
                        onClick={() => {
                          self.handleCommonTracking('whatsapp', item);
                          window.open(`whatsapp://send?phone=+91${item.whatsapp_number}&text=Hi%20I%20found%20your%20shop%20on%20BharatPe%20App%2C%20are%20you%20open%20during%20lockdown%3F`);
                        }}
                        style={{ outline: "none" }}
                      >
                        <img src={whatsAppIcon} alt="whatsapp icon" />
                        WhatsApp
                      </button>

                      <button
                        onClick={() => {
                          self.handleCommonTracking('pay', item);
                           window.open(item.upi_intent);
                        }}
                        style={{ outline: "none" }}
                      >
                        Pay Now!
                      </button>
                    </div>

                  </div>
                </div>   
              );
            })}
          </div>

        {/* <div className={cx("scanpay--overlay", { "visible": state.expandScanPayVisible })} onClick={() => this.setState({ expandScanPayVisible: false })}></div> */}
        <div
          className={"scanpay-banner expanded"}
          onClick={() => {
            this.trackEvent('consumer_lockdown_scanpay_playstore', {});
            window.open('https://play.google.com/store/apps/details?id=in.scanpay.app');
          }}
        >
          <h1 className="heading">
            All Payment Apps in <b>One App</b>
          </h1>
          <div className="flex tc">
            <span className="download-text">Download</span>
          </div>

          <div className="download-CTA-container tc">
            <button
              className="download-CTA"
              onClick={() => {
                window.open('https://play.google.com/store/apps/details?id=in.scanpay.app')
              }}
            >
              <img className="scanpay-logo" src={scanPayLogoBlack} alt="scanpay logo"/>
              Download Now
            </button>
          </div>
        </div>

        <img
          src={state.onePixelImageURL}
          alt="&nbsp;"
          style={{
            display: "none",
          }}
        />
      </div>
    );
  }
}

export default Home;